import { LocalStorageGarageProvider } from './local-provider';
import { syncGlobalGarageIcon, syncGarageIcons } from './utils';

class LocalGarageImpl {
  #provider;

  constructor() {
    this.#provider = dsp.garage || new LocalStorageGarageProvider();
  }

  init() {
    syncGlobalGarageIcon();
    syncGarageIcons();
  }

  has(id) {
    return this.#provider.has(parseInt(id));
  }

  isEmpty() {
    return this.#provider.isEmpty();
  }

  empty() {
    this.#provider.reset();
  }

  remove(id) {
    this.#provider.remove(parseInt(id));
  }

  add(id) {
    this.#provider.add(parseInt(id));
  }
}

export const LocalGarage = new LocalGarageImpl();
